module.exports = __webpack_public_path__ + "media/images/voice07-2-b87a286a120fe25c444875cc2c673867.jpg";